/** @format */

const imageConstants = {
    FALLBACKS: {
        NO_DATA: '@tenant/app/assets/fallbackImages/no_events_available.png',
        NO_TICKETS: '@tenant/app/assets/fallbackImages/no_tickets_available.png',
        NOT_FOUND: '@tenant/app/assets/fallbackImages/404.png',
        SPORTS: '@tenant/app/assets/fallbackImages/sports.png',
        ARTS: '@tenant/app/assets/fallbackImages/arts.png',
        CONCERTS: '@tenant/app/assets/fallbackImages/concerts.png',
        FAMILY: '@tenant/app/assets/fallbackImages/family.png',
        OTHER_EVENTS: '@tenant/app/assets/fallbackImages/other_events.png',
        EVENT_TICKETS_MAINTENANCE:
            '@tenant/app/assets/fallbackImages/event_tickets_maintenance.png',
    },
};

export default imageConstants;
